import {NxFormikInput} from '@nextbank/ui-components';
import React, {useContext} from 'react';
import {ConfiguredField} from '../../../../../../shared/model/field.model';
import {StepContext} from '../loan-application-step/LoanApplicationStep';
import {ConfiguredFieldWrapper} from './ConfiguredFieldWrapper';
import {FieldDisablementReason} from './field-disablement-reason.model';

interface Props {
  field: ConfiguredField;
  label: React.ReactNode;
  name: string;
  disablementReason?: FieldDisablementReason;
}

export const ConfiguredFieldInput = ({field, label, name, disablementReason}: Props): React.ReactElement => {

  const {isStepReadonly} = useContext(StepContext);

  return (
    <ConfiguredFieldWrapper enabled={field.enabled} disablementReason={disablementReason}>
      <NxFormikInput disabled={isStepReadonly || !!disablementReason}
                     required={field.required}
                     name={`${name}.value`}
                     label={label} />
    </ConfiguredFieldWrapper>
  );
};
